import React, { useState } from "react";
import { HelpCircle } from "lucide-react";

/**
 * Compact help tooltip that opens on hover (desktop) and tap (mobile).
 * Max 2 lines of body text.
 */
export function InfoTooltip({ text, testId }) {
  const [open, setOpen] = useState(false);
  return (
    <span className="relative inline-flex items-center align-middle">
      <button
        type="button"
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onClick={() => setOpen((v) => !v)}
        className="text-[var(--rg-muted)] hover:text-[var(--rg-sage)] transition-fast"
        aria-label="More info"
        data-testid={testId || "info-tooltip-trigger"}
      >
        <HelpCircle className="w-3.5 h-3.5" />
      </button>
      {open && (
        <span
          role="tooltip"
          className="absolute z-50 left-1/2 -translate-x-1/2 top-full mt-1.5 w-56 max-w-[80vw] rounded-md border border-[var(--rg-sage-border)] bg-[var(--rg-bg)] p-2.5 text-[11px] leading-snug text-[var(--rg-text)] shadow-lg whitespace-normal"
          data-testid={(testId || "info-tooltip-trigger") + "-content"}
        >
          {text}
        </span>
      )}
    </span>
  );
}
